import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  router = inject(Router);
  private _auth = inject(AuthService);

  constructor() {
    this._tryRestoreSession();
  }

  private async _tryRestoreSession(): Promise<void> {
    const token = localStorage.getItem('token');
    if (!token) return;

    if (!this._isTokenExpired(token)) {
      this._auth.currentUserToken.set(token);
      this.router.navigate(['/select-organization']);
      return;
    }

    const refreshed = await this._auth.refreshToken();
    if (refreshed) {
      this.router.navigate(['/select-organization']);
    }
  }

  private _isTokenExpired(token: string): boolean {
    try {
      const decoded: any = jwtDecode(token);
      return decoded.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  }
}
